module.exports = "a.users {\n    text-decoration: none;\n    cursor: pointer;\n}\n\nimg.profile-image {\n    max-width: 25px;\n    max-height: 25px;\n}"